import { api } from '@mbfab/client-api'
import { useRedirect } from '@mbfab/frontend-common'
import { isSome } from '@mbfab/shared'
import { Button, Layout, Result } from 'antd'
import type { AppProps } from 'next/app'
import { Suspense, useRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

import { ErrorPage } from '../components/ui/ErrorPage'
import { SuspenseWithLoading } from '../components/ui/SuspenseWithLoading'
import { routes } from '../config/routes'
import { AuthenticatedApolloProvider } from '../providers/AuthenticatedApolloProvider'

import { DefaultHead } from './base/DefaultHead'
import { AdminSider } from './member/AdminSider'

export const AdminLayout = (props: AppProps) => {
  return (
    <Suspense>
      <AuthenticatedApolloProvider>
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <SuspenseWithLoading>
            <>
              <Suspense>
                <LogicBodyWrapper {...props} />
              </Suspense>
            </>
          </SuspenseWithLoading>
        </ErrorBoundary>
      </AuthenticatedApolloProvider>
    </Suspense>
  )
}

function LogicBodyWrapper(appProps: AppProps) {
  const nodeRef = useRef<HTMLDivElement>(null)
  const redirect = useRedirect()
  const myIdentityQuery = api.useFetchMyIdentityQuery()
  if (isSome(myIdentityQuery.error)) {
    return <ErrorPage error={myIdentityQuery.error} />
  }
  const me = myIdentityQuery.data?.myIdentity
  if (me === undefined) {
    return <></>
  }
  if (me.role !== 'admin') {
    return (
      <div className="flex h-screen items-center justify-center p-6">
        <Result
          status="error"
          title="権限がありません"
          subTitle="このページにアクセスする権限がありません。別のアカウントでログインし直してください。"
          extra={
            <Button
              type="link"
              onClick={() => {
                redirect(routes.signOutPath())
              }}
            >
              ログアウト
            </Button>
          }
        />
      </div>
    )
  }

  return (
    <>
      <DefaultHead />
      <Suspense fallback={<div>loaidng</div>}>
        <Layout style={{ height: '100%' }} className="w-full">
          <AdminSider />
          <Layout.Content className={`overflow-visible-print h-full overflow-y-auto pb-16`}>
            <SwitchTransition>
              <CSSTransition key={appProps.router.asPath} timeout={200} classNames="page-transition" nodeRef={nodeRef}>
                <div ref={nodeRef}>
                  <Suspense>
                    <appProps.Component />
                  </Suspense>
                </div>
              </CSSTransition>
            </SwitchTransition>
          </Layout.Content>
        </Layout>
      </Suspense>
    </>
  )
}
